<template>
    <div class="stars_home_div">
        <Stars></Stars>
    </div>
</template>

<script type="text/javascript">

import Stars from '@/components/stars_page/stars.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        Stars,
    },
    methods: {
        ...mapActions({
            get_path_information: 'path/change_path_information'
        })
    },

    mounted: function () {
        this.get_path_information()
    }
}
</script>
<style type="text/css">
</style>
